module.exports = __webpack_public_path__ + "static/media/free-charge.bf729d7a.png";